module.exports = "  <footer class=\"main-footer\">\n    <div class=\"pull-right hidden-xs\">\n      <b>Version</b> 0.0.1\n    </div>\n    <strong>Copyright &copy; 2017-2019 <a href=\"#\">Best regards Studio</a>.</strong> All rights\n    reserved.\n  </footer>"


//////////////////
// WEBPACK FOOTER
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/footer/footer.component.html
// module id = ../../../../../src/app/dashboard/footer/footer.component.html
// module chunks = main